import { BaseAction } from './BaseAction';
import { NewsletterEngine } from '../engines/NewsletterEngine';
export class NewsletterAction extends BaseAction {
    execute() {
        var _a;
        const preferences = NewsletterEngine.getPreferences(this.action);
        // Mirror Connext v2 Newsletter.prepareToShow():
        // if the user is already subscribed to all preferences, skip the action entirely — do NOT render.
        if (NewsletterEngine.isUserAlreadySubscribed(preferences)) {
            return false;
        }
        // Render the template HTML into the DOM
        this.renderTemplate();
        // Autofill email from user store or localStorage
        const step = (_a = document.querySelector("[data-nxt-template-step='Newsletter']")) !== null && _a !== void 0 ? _a : document.body;
        NewsletterEngine.autofillEmail(step);
        // Bind the subscribe button
        NewsletterEngine.bindSubmit(this.action);
        return true;
    }
}
